// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"585":"531e06d7","610":"e074bb84"}[chunkId] + ".chunk.css";
};